import type { ScoreInput } from '../types/entities';

export const scoreWeights: Record<keyof ScoreInput, number> = {
  reliability: 0.3,
  taskFit: 0.25,
  toolCompatibility: 0.2,
  costEfficiency: 0.15,
  evidenceQuality: 0.1
};

export function calculateOrchestrationScore(input: ScoreInput): number {
  const weightedScore = Object.entries(scoreWeights).reduce((total, [key, weight]) => {
    const value = input[key as keyof ScoreInput];
    return total + clampMetric(value) * weight;
  }, 0);

  return Math.round(weightedScore * 100) / 100;
}

export function scoreBadge(score: number): 'excellent' | 'good' | 'watch' {
  if (score >= 85) return 'excellent';
  if (score >= 70) return 'good';
  return 'watch';
}

function clampMetric(value: number): number {
  return Math.max(0, Math.min(100, value));
}
